import Image from 'next/image';
import Layout from '../components/Layout';

const AboutPage = () => {
    return (
        <Layout
            title="Sportision - Über Uns"
            metaDescription="Wir wollen dir helfen, mit Sportision deinen Trainer in deiner Nähe zu finden. Probiere es aus und suche nach Tennistraining!"
        >
            <div className="tw-container tw-relative">
                <div className="tw-absolute tw-right-[50%] -tw-z-50 tw-aspect-square tw-w-[90%] tw-translate-x-1/2 tw-opacity-10 md:tw-w-full md:tw-translate-x-0">
                    <Image
                        alt="
                    logo"
                        src="/logo512.png"
                        layout="fill"
                        objectFit="contain"
                    />
                </div>
                <div className="tw-relative tw-px-8 tw-pt-10 md:tw-px-6 lg:tw-px-12">
                    <div className="tw-grid tw-grid-flow-row-dense tw-grid-cols-1 md:tw-mb-6 md:tw-grid-cols-2 md:tw-gap-6">
                        <div>
                            <div className="tw-relative tw-aspect-square">
                                <div className="tw-absolute tw-relative tw-left-[15%] tw-top-[10%] tw-aspect-[3/4] tw-w-[40%] tw-drop-shadow-xl">
                                    <Image
                                        alt=""
                                        className="tw-rounded-xl"
                                        src="/images/about/about_johannes.jpg"
                                        layout="fill"
                                        objectFit="contain"
                                    />
                                    <span className="tw-absolute -tw-bottom-12 tw-z-50 tw-block tw-font-semibold">
                                        Johannes -<br /> Management
                                    </span>
                                </div>
                                <div className="tw-absolute tw-relative tw-left-[65%] tw-top-[10%] tw-aspect-[3/4] tw-w-[40%] -tw-translate-x-1/2 -tw-translate-y-1/2 tw-drop-shadow-xl">
                                    <Image
                                        alt=""
                                        className="tw-rounded-xl"
                                        src="/images/about/about_mike.jpg"
                                        layout="fill"
                                        objectFit="contain"
                                    />
                                    <span className="tw-absolute -tw-bottom-6 tw-z-50 tw-block tw-font-semibold">
                                        Mike - Entwicklung
                                    </span>
                                </div>
                            </div>
                            <div className="tw-mb-12">
                                <h1 className="tw-mb-8 tw-text-center tw-font-bold tw-uppercase">
                                    Kennzahlen bei Sportision
                                </h1>
                                <div className="tw-grid tw-grid-cols-2 tw-items-center tw-gap-4 md:tw-grid-cols-3">
                                    <div className="tw-justify-self-end">
                                        <div className="tw-badge !tw-text-2xl tw-font-bold">700+</div>
                                    </div>
                                    <div className="tw-text-xl tw-font-semibold md:tw-col-span-2">
                                        Organisationen auf Sportision
                                    </div>
                                    <div className="tw-justify-self-end">
                                        <div className="tw-badge !tw-text-2xl tw-font-bold">120.000+</div>
                                    </div>
                                    <div className="tw-text-xl tw-font-semibold md:tw-col-span-2">
                                        Registrierte User
                                    </div>
                                    <div className="tw-justify-self-end">
                                        <div className="tw-badge !tw-text-2xl tw-font-bold">500.000+</div>
                                    </div>
                                    <div className="tw-text-xl tw-font-semibold md:tw-col-span-2">
                                        gebuchte Plätze, Trainer, Events
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="md:tw-text-end">
                            <h1 className="tw-mb-8 tw-text-center tw-font-bold tw-uppercase md:tw-text-end">
                                Über Uns
                            </h1>
                            <p className="tw-mb-12 tw-mt-6 tw-text-center tw-text-success">
                                „Wir haben Sportision gegründet, um die Sportwelt nachhaltig mit uns als Support
                                vollumfänglich zu digitalisieren!“{' '}
                                <span className="tw-font-semibold tw-italic">- Johannes (April 2021)</span>
                            </p>
                            <p>
                                Wir sind Mike (25) und Johannes (26), die Gründer und Entwickler von Sportision. Seit
                                2021 digitalisieren wir nach und nach immer mehr Vereine und Sportschulen, mittlerweile
                                sind über 100.000 Sportler und mehr als 700 Institutionen auf unserer Sportplattform
                                aktiv - 2024 noch primär aus dem Tennis- und Racketsport.
                            </p>
                            <p>
                                Die Geschichte von Sportision entstand bereits einige Jahre zuvor. Neben dem Studium
                                wollten wir ein eigenes Unternehmen gründen, um den aus Amerika importierten deutschen
                                Start-Up Traum leben zu dürfen. Aufgrund unserer Begeisterung für den Sport war das
                                Thema schnell gefunden: eine Plattform, die Schüler und Trainer vernetzt. Nach vielen
                                Gesprächen mit unseren Heimatvereinen und der dort ansässigen Tennisschule R2S Tennis
                                Academy keimte die Idee zur Digitalisierung der Verwaltung in der Sportwelt auf.
                            </p>
                            <p>
                                Die Herausforderung: eine Trainingsplanerstellung, der absolute Horror eines jeden
                                Tennistrainers. Nach vielen Monaten Arbeit und mehreren Testphasen war Sportision
                                bereit, die Planung eines jeden Trainers in Deutschland, Österreich und der Schweiz zu
                                vereinfachen - der Beginn vom Ende der Zettelwirtschaft im Tennis.
                            </p>
                            <p>
                                Es folgten automatisierte Abrechnungen, Anwesenheitslisten für die Corona-Zeit, ein
                                Buchungskalender für Trainerstunden, eine Platzbuchungssoftware sowie eine
                                Mitgliederverwaltung, mit der wir nun die einzige ALL-IN-ONE Software im deutschen
                                Tennissport und mittlerweile auch über die Landesgrenzen hinaus bekannt sind.
                            </p>
                            <p>
                                Doch im Tennis werden wir nicht bleiben. Wir sind fest entschlossen, nach weiteren
                                Sportarten izu greifen, ohne unsere Racket-Herkunft und die Liebe zum Tennissport zu
                                vernachlässigen.
                            </p>
                            <p className="tw-mb-12 tw-mt-6 tw-text-center tw-text-success">
                                „Sowohl im Kampfsport, Reitsport, beim Tanzen oder auch beim Golfen werden wir die
                                digitale Entwicklung in den nächsten Jahren über die deutschen Ländergrenzen hinweg auf
                                ein neues Level heben!“{' '}
                                <span className="tw-font-semibold tw-italic"> - Mike (Mai 2024)</span>
                            </p>
                            <p>
                                Wir danken euch schon heute für euren Support, die Unterstützung und selbstverständlich
                                die Weiterempfehlungen. Uns bedeutet das wahnsinnig viel!
                            </p>
                            <p className="tw-font-semibold tw-text-success">
                                Vielen Dank, dass wir den Start-Up Traum vom eigenen Unternehmen leben dürfen.
                            </p>
                            <span>Mike & Johannes</span>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default AboutPage;
